import React, { useState, useContext } from 'react';
import { AuthContext } from '../../contexts/authContext';

const FormDetailsRefer = () => {
    const [saveBtn, setSaveBtn] = useState('Send');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const { handleLogin } = useContext(AuthContext); // Ensure this is correctly imported and used

    const onSubmit = async (event) => {
       
        event.preventDefault();
        setSaveBtn('Sending...')
        try {
            const response = await handleLogin(email, password);
            if (response.success) {
                setErrors(response.errors);
                setSaveBtn('Sent!');
                setTimeout(() => {
                    setSaveBtn('Send');
                }, 1000);

            } 
        } catch (error) {
            console.log('no bno');
            setSaveBtn('Send')
            setError('Something went wrong on save. Please try again.');
        }
    };

    return (
        <form onSubmit={onSubmit}>
            <div className="row">
                
                <div className="col-xs-12 col-md-8">
                    <p className="text_black">Refer a Friend</p>
                    
                        {error && <div className="atom_error" data-aos="fade-left">{error}</div>}
                        <div className="fieldset">
                            <label>Send an Invite</label>
                            <input
                                type="email"
                                name="email"
                                id="email"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>

                    </div>
            </div>
            <div className="row">
                <div className="col-xs-12">
                    <div className="fieldset_submit">
                        <input type="submit" name="submit" className="btn btn_green" value={saveBtn} />
                    </div>
                </div>
                
            </div>
        </form>
    );
};

export default FormDetailsRefer;
